module.exports = __webpack_public_path__ + "static/react-31c22db28e8b78512cad6acd0412ae8f.png";